import React, { FC, useState } from 'react';
import { IResourceCardProps } from './models';
import DangerouslySetInnerHtml from '../DangerouslySetInnerHtml';
import YoutubeModal from './YoutubeModal';
import ImageDownloader from './ImageDownloader';
import './style.scss';

const ResourceCard: FC<IResourceCardProps> = (props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const imageDownloadLink = {
    image: props?.resourceImg,
    imageAlt: props?.resourceImgAlt,
  };

  return (
    <div className="resource-cards__item">
      <div className="resource-cards__item-image">
        {!props?.isResourceVideo ? (
          <ImageDownloader
            linkName={props?.resourceLinkName}
            imgWithLink={imageDownloadLink}
            downloadURL={props?.resourceUrl}
            showLabel={false}
          />
        ) : (
          <button onClick={() => setModalOpen(true)} className="img-btn">
            <img src={props?.resourceImg.url} alt={props?.resourceImgAlt} />
          </button>
        )}
        {modalOpen && (
          <YoutubeModal
            resourceUrl={props?.resourceUrl}
            name={props?.resourceTitle}
            setModalOpen={setModalOpen}
          />
        )}
      </div>
      <div className="resource-cards__item-text">
        <h4 className="resource-title">{props?.resourceTitle}</h4>
        <DangerouslySetInnerHtml
          element={'div'}
          html={props?.resourceDescription}
          className="resource-desc"
        />
        <div className="resource-cards__item-action">
          {!props?.isResourceVideo ? (
            <ImageDownloader
              linkName={props?.resourceLinkName}
              downloadURL={props?.resourceUrl}
              showLabel={true}
            />
          ) : (
            <button onClick={() => setModalOpen(true)} className="img-btn">
              {props?.resourceLinkName}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResourceCard;
